/**
 * "GENERAL" → "General", "OTHER BLACK" → "Other Black".
 *
 * Backend enums and reference data arrive shouting; screens should not. Capitalises the
 * first letter of every word, so hyphenated and multi-word values come through intact
 * ("Smith-Jones", not "Smith-jones").
 *
 * Two local copies of this already exist — `features/drugsFile/columns.jsx` and
 * `features/pregnancy/hooks/useConsultantOptions.js` — doing the same job. They are left
 * alone here rather than migrated as a side effect of an unrelated change, but this is the
 * one new code should use.
 */
export const toTitleCase = (value) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/\b\p{L}/gu, (letter) => letter.toUpperCase());
